import { cn } from "@/lib/utils";

export type BoardCardSignal = {
  key: string;
  label: string;
  dotClassName: string;
};

/** Gray strip at the foot of a board card: what the record needs, in words. */
export const BoardCardStrip = ({
  signals,
  className,
}: {
  signals: BoardCardSignal[];
  className?: string;
}) =>
  signals.length > 0 ? (
    <div
      className={cn(
        "flex min-w-0 items-center gap-3 border-t bg-muted/50 px-3 py-1.5 text-xs",
        className,
      )}
    >
      {signals.map((signal, index) => (
        <span
          key={signal.key}
          className={cn(
            "flex min-w-0 items-center gap-1.5",
            index === 0 ? "flex-1" : "shrink-0",
          )}
        >
          <span
            aria-hidden
            className={cn("size-2 shrink-0 rounded-full", signal.dotClassName)}
          />
          <span className="truncate font-medium text-foreground">
            {signal.label}
          </span>
        </span>
      ))}
    </div>
  ) : null;
